
export const pricing = {
  'request.pricing': 'Request Pricing',
  'view.pricing': 'View Pricing',
  'product.pricing': 'Product Pricing',
};
